module.exports = __webpack_public_path__ + "img/lading-hero-c.84963ee.jpg";